export enum MaterialType {
  // 0：默认、1：图片、2：视频、3：招商计算器
  DEFAULT = 0,
  PICTURE = 1,
  VIDEO = 2,
  INVESTMENT_CALCULATOR = 3,
}
